import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { fmtErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { BookOpen } from "lucide-react";

const inputCls = "mt-1 w-full bg-white border border-neutral-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-neutral-900 outline-none";

export default function Claim() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [info, setInfo] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) { setError("Missing claim token."); return; }
    api.get(`/auth/claim/${token}`)
      .then((r) => { setInfo(r.data); setEmail(r.data.email); })
      .catch((e) => setError(fmtErr(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/claim", { token, email, password });
      setUser(data);
      navigate("/dashboard");
    } catch (err) { setError(fmtErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 font-bold text-xl font-heading text-neutral-900 mb-8">
          <BookOpen size={24} /> GloriPub
        </Link>
        <div className="bg-white border border-neutral-200 rounded-lg p-8 shadow-sm" data-testid="claim-page">
          <h1 className="text-2xl font-semibold font-heading text-neutral-900">Claim your author account</h1>
          {info && <p className="text-sm text-neutral-500 mt-1 mb-6">Welcome, {info.name}. Set your login email and password to access your sales dashboard.</p>}
          {error && <div data-testid="claim-error" className="text-red-700 bg-red-50 border border-red-200 rounded-md p-3 text-sm my-4">{error}</div>}
          {info && (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-sm font-medium text-neutral-700">Your email (used to log in)</label>
                <input data-testid="claim-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
                <p className="text-xs text-neutral-400 mt-1">You can replace the placeholder email with your real one.</p>
              </div>
              <div>
                <label className="text-sm font-medium text-neutral-700">Choose a password (min 8 characters)</label>
                <input data-testid="claim-password-input" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
              </div>
              <button data-testid="claim-submit-button" disabled={loading}
                className="w-full py-2.5 rounded-md text-white bg-neutral-900 hover:bg-neutral-800 font-medium text-sm transition-colors disabled:opacity-50">
                {loading ? "Claiming..." : "Claim account & log in"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
